// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"_2DKf1","richHeading":"_2Io3T","customHeading":"BmBJM","richBody":"_3Vn6s","richLegal":"_2L4fi"};